/* Stick Videos-For-You section*/
(function () {
    $(document).ready(function() {
        "use strict";

        var $document = $(document);

        var $videoModule = $('#videos-for-you');

        var $footer = $('footer');

        var $stickyNav = $('.nav-sticky');

        var videoHeight = $videoModule.outerHeight();

        var $videoTop;

        var sticky;

        var stickyNavOffset;
        var stickyNavTop;
        var $entryContent = $('.entry__below-entry');
        var $colCenter = $('.col--body-center');
        /* Apply the stick logic */
        function stickVideos() {
            /* Reset the module to the original position */
            $videoModule.removeClass('stick');

            sticky = false;

            $videoTop = $videoModule.offset().top;
            
            if($stickyNav.length) { 
                stickyNavOffset = $stickyNav.outerHeight() - $stickyNav.position().top;
                stickyNavTop = $stickyNav.outerHeight() + $stickyNav.position().top;
            } else {
                stickyNavOffset = 60;
                stickyNavTop = 60;
            }
            if(!$entryContent.length || ($entryContent.length && $colCenter.height() - $entryContent.outerHeight() <= 0 ) ) {
                /*apply sticky unless the center content does not fill the full container (happens on entries)*/

                if($document.scrollTop() >= $footer.offset().top - videoHeight +  stickyNavOffset)
                {
                    /* Make the sticky module scrollable when it reaches the $footer */
                    sticky = true;
                    $videoModule.addClass('stick');
                    $videoModule.css('top' , $footer.offset().top - $document.scrollTop() - videoHeight - stickyNavOffset);
                }
                else if($document.scrollTop() >= $videoTop - stickyNavOffset)
                {
                    /* Make the module sticky at the top */
                    sticky = true;
                    $videoModule.addClass('stick');
                    $videoModule.css('top' , stickyNavTop);
                }
                else
                {
                    if(sticky === true)
                    {
                        /* Remove sticky feature */
                        $videoModule.removeClass('stick');
                    }
                }
            }
        }

        if($videoModule.length > 0 )
        {
            /* Apply the first time when the page loads  */
            stickVideos();
            $document.scroll(function() {

                stickVideos();

            });
        }

    });
}) ();